import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  postTitlesModal: boolean;
  selectedTitles: any[];
};

const initialState: InitialState = {
  postTitlesModal: false,
  selectedTitles: [],
};

const postTitlesSlice = createSlice({
  name: "postTitlesSlice",
  initialState,
  reducers: {
    togglePostTitleModal: (state, action: PayloadAction) => {
      state.postTitlesModal = !state.postTitlesModal;
      return state;
    },
    setTitles: (state, action: PayloadAction<any>) => {
      const checkDuplicate = state.selectedTitles.filter(
        (data) =>
          data.id === action.payload.id &&
          data.media_type === action.payload.media_type
      );
      if (checkDuplicate.length > 0) {
        return state;
      } else {
        state.selectedTitles = [...state.selectedTitles, action.payload];
        return state;
      }
    },
    removeTitles: (state, action: PayloadAction<any>) => {
      const filteredTiles = state.selectedTitles.filter(
        (data) =>
          data.id !== action.payload.id ||
          data.media_type !== action.payload.media_type
      );
      state.selectedTitles = filteredTiles;
      return state;
    },
    resetPostTitlesState: (state, action: PayloadAction) => {
      // state.postTitlesModal = false;
      state.selectedTitles = [];

      return state;
    },
  },
});

export const {
  togglePostTitleModal,
  setTitles,
  removeTitles,
  resetPostTitlesState,
} = postTitlesSlice.actions;
export default postTitlesSlice;
